import React from 'react'
import type { ButtonProps } from '@vtex/admin-ui'
import { Button, csx, IconX } from '@vtex/admin-ui'

export type CloseButtonProps = ButtonProps

export const CloseButton = (props: CloseButtonProps) => (
  <Button
    variant="neutralTertiary"
    icon={<IconX color="black" />}
    className={csx({
      position: 'absolute',
      top: '$space-1',
      right: '$space-4',
      zIndex: 5,
      '@desktop': {
        display: 'inline-block',
        top: '$space-7',
        right: '$space-7',
      },
    })}
    {...props}
  />
)
